"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HTTPLicenseAcquisitionStrategy = (function () {
    function HTTPLicenseAcquisitionStrategy(generateLicenseRequest, processLicenseResponse, createHTTPRequest) {
        var _this = this;
        this.generateLicenseRequest = generateLicenseRequest;
        this.processLicenseResponse = processLicenseResponse;
        this.createHTTPRequest = createHTTPRequest;
        this.createGetLicense = function (drmConfiguration) { return function (message, messageType) {
            var licenseRequestDescription = _this.generateLicenseRequest(drmConfiguration, message, messageType);
            return _this.createHTTPRequest(licenseRequestDescription.url, licenseRequestDescription).then(_this.processLicenseResponse);
        }; };
    }
    return HTTPLicenseAcquisitionStrategy;
}());
exports.default = HTTPLicenseAcquisitionStrategy;
